export default __webpack_public_path__ + "static/media/footerlogos.b2a34418.png";